<script>
import { Tabs, TabPane } from 'ant-design-vue';

export default {
  emits: ['onTabChange'],
  components: { Tabs, TabPane },
  props: {
    tabs: {
      type: Array,
      required: true,
    },
    activeKey: {
      type: String,
      default: '1',
    },
    destroyInactiveTabPane: {
      type: Boolean,
      default: false,
    },
  },
};
</script>

<template>
  <div>
    <Tabs
      :activeKey="activeKey"
      @change="(key) => $emit('onTabChange', key)"
      :destroyInactiveTabPane="destroyInactiveTabPane"
    >
      <TabPane
        v-for="(item, i) in tabs"
        :key="`${i + 1}`"
        :tab="item.label || item"
        :disabled="item.disbled"
      >
        <slot name="tab-header"></slot>
        <slot :name="`tab-${i + 1}`"></slot>
        <slot name="tab-footer"></slot>
      </TabPane>
      <template #leftExtra>
        <slot name="leftExtra"></slot>
      </template>
      <template #rightExtra>
        <slot name="rightExtra"></slot>
      </template>
    </Tabs>
  </div>
</template>

<style lang="scss" scoped></style>
